import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { BusinessUser } from "../../../service/model/user.model";
import { useState } from "react";
import UserForm from "./user-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { deleteUser } from "../user.slice";
import TableActionButton from "../../../components/table/table-action-button";
import NoteModal from "../../notes/components/note-modal";
import { NoteTargetType, PermissionCode, UserType } from "../../../shared/enums";
import { EditIcon, ChecklistIcon, DeleteIcon, AttendanceIcon } from "../../../shared/icons";
import { getPermissionsForLoggedInUser } from "../../../shared/utils";
import { selectLoggedInUser } from "../../auth/auth.slice";
import { StaffAttendance, StaffAttendanceRequest } from "../../../service/model/staff-attendance.model";
import { createStaffAttendance } from "../../attendance/staff-attendance.slice";
import StaffAttendanceForm from "../../attendance/staff/staff-attendance-form";

interface TableRowProps {
    readonly user: BusinessUser
}

const UserTableRow: React.FC<TableRowProps> = ({ user }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showUserForm, setShowUserForm] = useState(false);
    const [showAttendanceForm, setShowAttendanceForm] = useState(false);
    const [showNoteModal, setShowNoteModal] = useState(false);

    const loggedInUser = useAppSelector(selectLoggedInUser);
    const loggedInUserPermissions = getPermissionsForLoggedInUser(loggedInUser);

    const handleDelete = () => {
        dispatch(deleteUser(user.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleAttendanceSubmit = (data: StaffAttendanceRequest) => {
        dispatch(createStaffAttendance({ ...data})).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowAttendanceForm(false);
            }
        });
    };

    // const handleSubmit = (data: BusinessUserRequest) => {
    //     loggedInUser && dispatch(updateUser({ ...data, id: user.id })).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowUserForm(false);
    //         }
    //     });
    // };

    return (
        <>
            <StyledTableRow key={user.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Username</Box>{user.user.username}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">First Name</Box>{user.firstName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Last Name</Box>{user.lastName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Role</Box>{user.role?.displayName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Contact</Box>{user.contact}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Expiry</Box>{node.branch.createdDate}</TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <IconButton onClick={() => setShowUserForm(true)} sx={{color: `${theme.palette.secondary.main}`, paddingLeft: 0}}><VisibilityIcon /></IconButton> */}

                    {loggedInUserPermissions.includes(PermissionCode.STAFF_ATTENDANCE_MARK) &&
                        <TableActionButton onClick={() => setShowAttendanceForm(true)} label="Mark Attendance" icon={<AttendanceIcon />} />
                    }
                    <TableActionButton onClick={() => setShowUserForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowNoteModal(true)} label="Notes" icon={<ChecklistIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    {/* <Link className="btn" to="#" data-toggle="modal" data-target="#delete-member-modal" onClick={() => setShowDeleteDialog(true)}><DeleteIcon /></Link> */}
                </TableCell>
            </StyledTableRow>
            {showUserForm &&
                <UserForm userType={UserType.BUSINESS_USER} user={user} editable={true} onClose={() => setShowUserForm(false)} />
            }
            {showAttendanceForm &&
                <StaffAttendanceForm attendance={{ businessUserId: user.id, businessUserName: `${user.firstName} ${user.lastName}` } as StaffAttendance} editable={true} onClose={() => setShowAttendanceForm(false)} onSubmit={handleAttendanceSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
            {showNoteModal &&
                <NoteModal target={user} targetType={NoteTargetType.STAFF} onClose={() => setShowNoteModal(false)} />
            }
        </>
    );
}

export default UserTableRow;